import {library} from "@fortawesome/fontawesome-svg-core"
import {faStoreAlt} from "@fortawesome/free-solid-svg-icons"

library.add(faStoreAlt)

const route = {
    path: "/general-origin-certificate",
    name: "GeneralOriginCertificate",
    meta: {
        icon: 'store-alt',
        layout: 'PageLayout'
    },
    children: [
        {
            path: "general-application",
            name: "GeneralApplicationComponent",
            component: () => import( /*webpackChunkName: "general-origin-certificate"*/ "./view/GeneralApplication.vue"),
            meta: {
                title: "一般原产地证书申请",
                isRequiredAuth: true,
                isRequiredEnterpriseAuth: true
            }
        },
        {
            path: "general-application-order-detail",
            name: "GeneralApplicationOrderDetail",
            component: () => import( /*webpackChunkName: "general-origin-certificate"*/ "./view/GeneralApplicationOrderDetail.vue"),
            meta: {
                title: "一般原产地证书详情",
                isRequiredAuth: true,
                isRequiredEnterpriseAuth: true
            }
        },
        {
            path: "provision",
            name: "Provision",
            component: () => import( /*webpackChunkName: "general-origin-certificate"*/ "./view/additional/Provision.vue"),
            meta: {
                title: "价格条款",
                isRequiredAuth: true,
                isRequiredEnterpriseAuth: true
            }
        },
        {
            path: "provision-add",
            name: "ProvisionAdd",
            component: () => import( /*webpackChunkName: "general-origin-certificate"*/ "./view/additional/ProvisionAdd.vue"),
            meta: {
                title: "添加价格条款",
                isRequiredAuth: true,
                isRequiredEnterpriseAuth: true
            }
        },
    ]
}

export default route